<template>
  <div class="card">
    <h3>实验报告上传接口</h3>
    <p>1。请先调用数据回传接口，然后再上传实验报告附件。</p>
    <p>2。实验报告附件最大不能超过5M。</p>
    <h4>接口调用请求说明</h4>
    <p>http请求方式：POST <a href="javascript:void(0)">http://xa.celer.cc/open/report_upload?filename=1.docx&originId=1&ticket=3d337d7bc***************************e3f84db3db7d2ce</a>
    </p>
    <h4>请求示例</h4>
    <p>
      curl -X POST --data '文件内容' 'http://xa.celer.cc/open/report_upload?filename=1.docx&originId=1&ticket=3d337d7bc***************************e3f84db3db7d2ce'
    </p>
    <h4>JSON字段说明</h4>
    <table class="param_table">
      <tr>
        <td>
          <h4>键值</h4>
        </td>
        <td>
          <h4>类型</h4>
        </td>
        <td>
          <h4>是否必须</h4>
        </td>
        <td>
          <h4>说明</h4>
        </td>
      </tr>
      <tr>
        <td>filename</td>
        <td>String</td>
        <td>是</td>
        <td>文件名称</td>
      </tr>
      <tr>
        <td>ticket</td>
        <td>String</td>
        <td>是</td>
        <td>按照步骤《获取Ticket》中的方法，获取到的ticket（登录票据）</td>
      </tr>
      <tr>
        <td>originId</td>
        <td>String</td>
        <td>是</td>
        <td>实验平台实验记录ID</td>
      </tr>
    </table>
    <h4>返回结果</h4>
    <p>正确时的返回JSON数据包如下：</p>
    <json-viewer
      class="code"
      :value="jsonData1"
    ></json-viewer>
    <p>
      错误时的返回JSON数据包如下（示例为参数缺失）：
    </p>
    <json-viewer
      class="code"
      :value="jsonData2"
    ></json-viewer>
    <h4>返回码说明：</h4>
    <table class="param_table">
      <tr>
        <td>
          <h4>返回码</h4>
        </td>
        <td>
          <h4>说明</h4>
        </td>
      </tr>
      <tr>
        <td>0</td>
        <td>保存成功</td>
      </tr>
      <tr>
        <td>1</td>
        <td>参数错误：ticket</td>
      </tr>
      <tr>
        <td>2</td>
        <td>参数错误：filename</td>
      </tr>
      <tr>
        <td>3</td>
        <td>参数错误：originId</td>
      </tr>
      <tr>
        <td>4</td>
        <td>非法 ticket</td>
      </tr>
      <tr>
        <td>5</td>
        <td>非法 ticket[U]</td>
      </tr>
      <tr>
        <td>6</td>
        <td>非法 ticket[E]</td>
      </tr>
      <tr>
        <td>7</td>
        <td>非法 ticket[ES]</td>
      </tr>
      <tr>
        <td>8</td>
        <td>文件类型应为.doc、.docx</td>
      </tr>
      <tr>
        <td>9</td>
        <td>实验平台实验记录ID错误！</td>
      </tr>
      <tr>
        <td>10</td>
        <td>文件类型应为.doc、.docx</td>
      </tr>
      <tr>
        <td>11</td>
        <td>文件最大5M</td>
      </tr>
      <tr>
        <td>20</td>
        <td>其他错误</td>
      </tr>
    </table>

  </div>
</template>

<script>
export default {
  name: 'ReportUpload',
  data: function () {
    return {
      jsonData1: {
        code: 0,
        msg: '保存成功'
      },
      jsonData2: {
        code: 1,
        msg: '参数错误：ticket'
      }
    }
  }
}
</script>

<style scoped>
.card {
  border: 1px solid #eee;
  padding: 20px;
  width: 100%;
  background-color: #fff;
  border-radius: 5px;
  box-sizing: border-box;
}

p {
  word-wrap: break-word;
  word-break: break-all;
}

a {
  word-wrap: break-word;
  word-break: break-all;
}

div {
  word-wrap: break-word;
  word-break: break-all;
}

.param_table {
  width: 800px;
}

.param_table tr td {
  border-bottom: 1px solid #ddd;
  padding: 7px;
}

.param_table tr td:first-child {
  width: 150px;
  text-align: left;
  vertical-align: top;
}

.param_table tr:last-child td {
  border-bottom: none;
}

.code {
  width: 1000px;
  padding: 7px;
  border-radius: 5px;
  border: 1px solid #aaa;
  background-color: #eee;
  margin-bottom: 15px;
}

.jv-container.jv-light {
  background: #eee;
}

h3,
h4,
h5 {
  margin-top: 20px;
  margin-bottom: 10px;
}
</style>
